/* eslint-disable no-nested-ternary */
import * as React from 'react';

import Text from 'crehana-ui/Text';
import {
  baseLighter,
  yellowMain,
  baseMain,
  white,
} from 'crehana-ui/styles/colors';

import Clock3 from 'crehana-icons/Clock3';
import Users from 'crehana-icons/Users';
import Star from 'crehana-icons/Star';
import Play3 from 'crehana-icons/Play3';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';
import { courseDuration } from 'Jsx/Utils/formatters';
import getSoftwareUrl from 'Jsx/Utils/course/getSoftwareUrl';
import LazyImageV2 from 'Jsx/Shared/LazyImageV2';

const Enrollments: React.FC<Partial<CourseCardProps>> = props => {
  const {
    enrollments,
    score,
    principalSoftware,
    principalSoftwareObj,
    hideSoftware,
    hideScore,
    dark,
    bundleCoursesLength,
    duration,
  } = props;

  const getSoftware = software => {
    if (software) {
      switch (typeof software) {
        case 'object':
          return software.originalImageUrl
            ? software.originalImageUrl
            : software.name
            ? getSoftwareUrl(software.name)
            : null;
        case 'string':
          return getSoftwareUrl(software) || null;
        default:
          return null;
      }
    }
    return null;
  };
  const currentSoftware = principalSoftwareObj || principalSoftware;

  return (
    <div
      className="EnrollmentsComponent flex items-center justify-between my-12 sm:my-16"
      css={`
        min-height: 30px;
      `}
    >
      <div>
        <div className="flex items-center">
          {typeof enrollments === 'number' && enrollments > 0 && (
            <div className="flex items-center mr-16">
              <Users size={24} color={baseLighter} />
              <Text
                type="body4"
                className="ml-8"
                color={dark ? 'white' : 'base-main'}
              >
                {enrollments}
              </Text>
            </div>
          )}
          {!hideScore && score && (
            <div className="flex items-center">
              <Star color={yellowMain} size={24} />
              <Text
                type="body4"
                className="ml-4 sm:ml-8"
                color={dark ? 'white' : 'base-main'}
              >
                {(
                  Math.ceil((score.average === 0 ? 5 : score.average) * 100) /
                  100
                ).toFixed(2)}
              </Text>
            </div>
          )}
        </div>
        {!!bundleCoursesLength && (
          <div className="flex items-center mt-12">
            <div className="flex items-center">
              <Play3 size={16} color={dark ? white : baseMain} />
              <Text
                type="body4"
                className="ml-8"
                color={dark ? 'white' : 'base-main'}
              >
                {`${bundleCoursesLength} cursos`}
              </Text>
            </div>
            {!!duration && (
              <div className="flex items-center ml-12">
                <Clock3 size={14} color={dark ? white : baseMain} />
                <Text
                  type="body4"
                  className="ml-4 sm:ml-8"
                  color={dark ? 'white' : 'base-main'}
                >
                  {courseDuration(duration)}
                </Text>
              </div>
            )}
          </div>
        )}
      </div>
      {!hideSoftware && getSoftware(currentSoftware) && (
        <div
          className="SoftwareComponent ml-auto"
          css={`
            min-width: 20px;
            height: 20px;
          `}
        >
          <LazyImageV2
            lazyUrl={getSoftware(currentSoftware)}
            imgxParams={{
              w: 20,
              h: 20,
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Enrollments;
